<template>
  <section class="footer">
    <template v-if="presentDetails">
      <table>
        <thead>
          <tr>
            <th v-for="(h, i) in header" :key="i">{{ h }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, i) in rows" :key="i">
            <td v-for="cell in row" :key="cell">{{ cell }}</td>
          </tr>
        </tbody>
      </table>
    </template>
  </section>
</template>
<script lang="ts" setup>
type Props = {
  presentDetails: boolean
  header: string[]
  rows: any[][]
}
defineProps<Props>()
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins';
@use '@/design-system/design-tokens/variables.scss';
section.footer {
  display: flex;
  flex-shrink: 0;
  width: 100%;
  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    margin-top: 30px;
    th,
    td {
      text-align: center;
    }

    th:first-child,
    td:first-child {
      text-align: left;
    }

    th:last-child,
    td:last-child {
      text-align: right;
    }
  }
  th {
    @include font-mixins.desktop-bold-tiny;
    color: variables.$color-greyscale-content;
    width: 33%;
    white-space: nowrap;
    text-align: left;
  }
  td {
    @include font-mixins.desktop-regular-tiny;
    color: variables.$color-greyscale-content;
    width: 33%;
    height: 20px;
    vertical-align: bottom;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
